import { setDataLayer } from '../../shared/constants/datalayer';
import { PaymentMethods } from './interface';
const lastPaymentDataKey = 'lastPayment';

const getPaymentLocationForAnalytics = (value: 'mobile-homepage' | 'mobile-coupon' | 'web-coupon' | ''): 'Koszyk' | 'SG' | 'Desktop' | 'False' => {
	switch (value) {
		case 'mobile-homepage':
			return 'SG';
		case 'mobile-coupon':
			return 'Koszyk';
		case 'web-coupon':
			return 'Desktop';
		default:
			return 'False';
	}
};

const onPaymentStarts = (data: {
	value: number;
	balance_before_payment: number;
	payment_method: string[];
	payment_stake_method: string[];
	deposit_count: number[];
	fast_payment: 'Koszyk' | 'SG' | 'Desktop' | 'False';
}) => {
	setDataLayer({
		event: 'payment_start',
		...data,
	});
	localStorage.setItem(lastPaymentDataKey, JSON.stringify(data));
};
const onPaymentEnds = (balanceAfterPayment: number, additionalParams?: { payment_method?: typeof PaymentMethods }) => {
	const data = localStorage.getItem(lastPaymentDataKey);
	if (data) {
		localStorage.removeItem(lastPaymentDataKey);
		const paymentData = JSON.parse(data);
		const dataLayer = {
			...paymentData,
			value: balanceAfterPayment - Number(paymentData.balance_before_payment),
			balance_after_payment: balanceAfterPayment,
			...additionalParams,
		};
		setDataLayer({
			event: 'deposit-success',
			...dataLayer,
		});
	}
};
const dataLayerPaymentManager = {
	onPaymentStarts,
	onPaymentEnds,
	getPaymentLocationForAnalytics,
};
export default dataLayerPaymentManager;
